import { Button } from "~/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "~/components/ui/dialog";
import { Textarea } from "~/components/ui/textarea";

interface ChildDatasetDenyRequestModalProps {
  open: boolean;
  denyReason: string;
  onDenyReasonChange: (value: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
  isDenying: boolean;
}

export function ChildDatasetDenyRequestModal({
  open,
  denyReason,
  onDenyReasonChange,
  onConfirm,
  onCancel,
  isDenying,
}: ChildDatasetDenyRequestModalProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && !isDenying && onCancel()}>
      <DialogContent onCloseButtonClick={onCancel}>
        <DialogHeader>
          <DialogTitle>Deny this request</DialogTitle>
          <DialogDescription>The requester will see this reason.</DialogDescription>
        </DialogHeader>
        <Textarea
          value={denyReason}
          onChange={(e) => onDenyReasonChange(e.target.value)}
          placeholder="Reason for denying this request…"
          disabled={isDenying}
          className="min-h-32"
          autoFocus
        />
        <DialogFooter>
          <Button
            variant="outline"
            size="lg"
            className="min-w-40"
            onClick={onCancel}
            disabled={isDenying}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            size="lg"
            className="min-w-40"
            loading={isDenying}
            onClick={onConfirm}
            disabled={isDenying || !denyReason.trim()}
          >
            Confirm denial
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
